import { ResponseData } from "src/app/@types/interfaces/get.response";
import { CoreService } from "./core.service";
import { ProgramData } from "src/app/@types/interfaces/youth.dashboard";
import data from "src/app/data/youth-dashboard-data.json";
import { HostProgramData } from "src/app/@types/interfaces/host.dashboard";
import hostDashboardData from "src/app/data/host-dashboard-data.json";
import { OverviewProgramData } from "src/app/@types/interfaces/admin-dashboard.interface";
import overviewData from "src/app/data/admin-dashboard-data.json";

interface YouthDashboardResponse {
  programs: ProgramData[];
}

interface HostDashboardResponse {
  programs: HostProgramData[];
}

interface OverviewResponse {
  programs: OverviewProgramData[];
}

export default class YouthDashboardService extends CoreService {
  async getYouthDashboardData(): Promise<ResponseData<YouthDashboardResponse>> {
    return new Promise((resolve, reject) => {
      try {
        // For now, return the JSON data
        // Later this can be replaced with actual API call
        const response = {
          success: true,
          message: "Youth dashboard data retrieved successfully",
          data: data as YouthDashboardResponse,
        };
        resolve(response);
      } catch (error) {
        const errorMessage =
          error instanceof Error
            ? error.message
            : "Failed to load youth dashboard data";
        reject(new Error(errorMessage));
      }
    });
  }

  async getHostDashboardData(): Promise<ResponseData<HostDashboardResponse>> {
    return new Promise((resolve) => {
      // This is a mock implementation using static data
      setTimeout(() => {
        resolve({
          success: true,
          message: "Host dashboard data fetched successfully",
          data: hostDashboardData as HostDashboardResponse,
        });
      }, 500);
    });
  }

  async getProgramOverviewData(): Promise<ResponseData<OverviewResponse>> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: "Program overview data fetched successfully",
          data: { programs: overviewData.programs },
        });
      }, 300);
    });
  }
}

export const dashboardService = new YouthDashboardService();
